import { createFileRoute } from "@tanstack/react-router";
import { StorybookLayout } from "../../../pages/storybook-layout";

export const Route = createFileRoute("/_auth/_frame/storybook")({
  component: StorybookLayout,
});
